import { Box, Flex } from "@chakra-ui/react";
import TopTab from "./TopTab";
import Header from "./Header";
import { useState, useEffect, useRef } from "react";
import { useAccount } from "wagmi"; // 假设使用wagmi获取钱包地址
import { getRecipientOrders, getSenderOrders, Order } from "@/api/order";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import BalanceContent from "./BalanceContent";
import ActivityContent from "./ActivityContent";
import QRScan from "./QRScan";
import { useUserInfo } from "@/context/UserInfo";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from "swiper";
import { BottomSheetRef } from "react-spring-bottom-sheet";
import { defaultSnapProps } from "react-spring-bottom-sheet/dist/types";
dayjs.extend(relativeTime);

const UserHome = () => {
  const account = useAccount();
  const address = account.address;
  const sheetRef = useRef<BottomSheetRef>(null);
  const [overlayOpacity, setOverlayOpacity] = useState(0);
  const [init, setInit] = useState(false);
  const [showQR, setShowQR] = useState(false);

  const [activeIndex, setActiveIndex] = useState(1);
  const [activityList, setActivityList] = useState<Order[]>([]);
  const swiperRef = useRef<SwiperType>();
  const [progress, setProgress] = useState(0.5);
  const timer = useRef<NodeJS.Timeout | null>(null);
  const [operated, setOperated] = useState(false);

  const handleOnOverlayOpacity = (opacity: number) => {
    setOverlayOpacity(opacity);
  };

  const getOrderList = async () => {
    try {
      const res = await getSenderOrders({ sender: address! });
      setActivityList(res);
      // setActivityList(res.data);
    } catch (error) {
      console.error("获取订单列表失败:", error);
    }
  };

  const handleActiveChange = (index: number) => {
    setActiveIndex(index);
    swiperRef.current?.slideTo(index);
  };

  useEffect(() => {
    if (!address) {
      return;
    }
    getOrderList();
  }, [address]);

  const getBgColor = (progress: number) => {
    if (progress >= 0.5) return "#D0732C";
    const startColor = { r: 51, g: 51, b: 51 }; // #333333
    const endColor = { r: 208, g: 115, b: 44 }; // #D0732C

    const ratio = progress * 2; // 将0-0.5的范围映射到0-1
    const r = Math.round(startColor.r + (endColor.r - startColor.r) * ratio);
    const g = Math.round(startColor.g + (endColor.g - startColor.g) * ratio);
    const b = Math.round(startColor.b + (endColor.b - startColor.b) * ratio);

    return `rgb(${r}, ${g}, ${b})`;
  };

  return (
    <Flex
      sx={{
        background: getBgColor(progress),
        height: "100%",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        overflow: "auto",
      }}
    >
      <Header />
      <TopTab activeIndex={activeIndex} onActiveChange={handleActiveChange} />
      <Swiper
        slidesPerView={1}
        initialSlide={1}
        onSlideChange={(swiper) => {
          setActiveIndex(swiper.activeIndex);
        }}
        onProgress={(swiper, progress) => {
          if (!init) {
            setInit(true);
            return;
          }
          if (!operated) {
            setOperated(true);
          }
          if (timer.current) {
            clearTimeout(timer.current);
          }
          if (progress === 0.5) {
            timer.current = setTimeout(() => {
              setProgress(progress);
            }, 100);
          } else {
            setProgress(progress);
          }

          if (progress === 0) {
            setShowQR(true);
          }
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        style={{
          width: "100%",
          flex: 1,
          marginTop: "15px",
        }}
      >
        <SwiperSlide style={{ height: "100%", position: "relative" }} key={0}>
          {operated && showQR && <QRScan onActiveChange={handleActiveChange} />}
        </SwiperSlide>
        <SwiperSlide style={{ height: "100%", position: "relative" }} key={1}>
          <BalanceContent
            isActive={progress === 0.5}
            overlayOpacity={overlayOpacity}
            sheetRef={sheetRef}
            handleOnOverlayOpacity={(opacity: number) => {
              handleOnOverlayOpacity(opacity);
            }}
          />
        </SwiperSlide>
        <SwiperSlide style={{ height: "100%", position: "relative" }} key={2}>
          <ActivityContent list={activityList} />
        </SwiperSlide>
      </Swiper>
      {overlayOpacity > 0 && (
        <Box
          position="fixed"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bg="blackAlpha.600"
          zIndex={1}
          opacity={overlayOpacity}
          transition="opacity 0.2s"
          pointerEvents={overlayOpacity > 0 ? "auto" : "none"}
          onClick={() => {
            sheetRef.current?.snapTo((state: defaultSnapProps) => {
              return state.snapPoints[state.snapPoints.length - 1];
            });
          }}
        />
      )}
    </Flex>
  );
};

export default UserHome;
